import classNames from 'classnames'

import type { TextProps } from '@/shared/components/typography/Title'

import { levels, colors, weights, styles } from '@/styles/shared/typography'

const Text = ({ level, color, weight, children, style, className }: TextProps) => {
  return (
    <div
      className={classNames(
        levels[level],
        color ? colors[color] : '',
        weight ? weights[weight] : '',
        style ? styles[style] : '',
        className
      )}
    >
      {children}
    </div>
  )
}

export default Text
